"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function shikumi_map() {
    window.addEventListener('load', (_event) => {
        const images = [
            '01-normal.png',
            '02-haguruma.png',
            '03-furui.png',
            '04-usu.png',
            '05-mizuwa.png',
            '06-shinbo.png',
            '07-kine.png',
        ];
        const map_image = document.getElementById('map-image');
        if (map_image) {
            images.forEach((img) => {
                const elid = img.match(/^01-/) ? 'map-image' : img.replace(/\.png/, '');
                const elm = document.getElementById(elid);
                console.log(elid, elm);
                if (elm) {
                    elm.addEventListener('mouseover', (_event) => {
                        map_image.setAttribute('src', `shikumijs/${img}`);
                        return false;
                    });
                }
            });
        }
    });
}
exports.default = shikumi_map;
